import { useMutation } from "@tanstack/react-query";
import { viewedContents } from "../queries/useHistory";

const useGetUserHistory = () => {
  const { mutate } =  useMutation({
    mutationKey: ['viewedContents'],
    mutationFn: () => viewedContents(),
  });

  return { mutate };
};

export default useGetUserHistory;